import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type { IApiPaginatedResponse, IApiResponse } from "@/types";
import type { ISingleTeam } from "@/types/(company)/teams.interface";
import type { IMSTeamStats, ITeamDetailsWithMembers } from "@/types/(my-space)/teams.interface";
import { createApi } from "@reduxjs/toolkit/query/react";

export const msTeamsApi = createApi({
  reducerPath: "msTeamsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["GetMyTeams", "GetTeamMembers"],
  endpoints: (builder) => ({
    getMyTeams: builder.query<
      IApiPaginatedResponse<ISingleTeam[]>,
      { search?: string; page?: number; limit?: number; createdFrom?: string; createdTo?: string }
    >({
      query: (params) => ({
        url: APIEndpoints.MySpace.Teams.GetMyTeams,
        params,
      }),
      providesTags: ["GetMyTeams"],
    }),
    getTeamMembers: builder.query<IApiResponse<ITeamDetailsWithMembers>, { teamId: number }>({
      query: ({ teamId }) => ({
        url: APIEndpoints.MySpace.Teams.GetTeamMembers(teamId),
      }),
      providesTags: ["GetTeamMembers"],
    }),
    getTeamsStats: builder.query<IApiPaginatedResponse<IMSTeamStats>, void>({
      query: () => ({
        url: APIEndpoints.MySpace.Teams.GetTeamStats,
      }),
      providesTags: ["GetTeamMembers"],
    }),
  }),
});

export const { useGetTeamsStatsQuery, useGetMyTeamsQuery, useGetTeamMembersQuery, useLazyGetTeamMembersQuery } =
  msTeamsApi;
